import classNames from 'volta/helpers/class-names';
import isStuck from 'volta/modifiers/is-stuck';

import type { TOC } from '@ember/component/template-only';

export interface BvModalFooterSignature {
  Args: {
    sticky?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const BvModalFooterComponent: TOC<BvModalFooterSignature> = <template>
  <footer
    class={{classNames 'bv-modal__footer' (if @sticky 'bv-modal__footer--sticky')}}
    {{isStuck @sticky rootMargin='0px 0px -1px 0px'}}
    ...attributes
  >
    {{yield}}
  </footer>
</template>;

export default BvModalFooterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::Footer': typeof BvModalFooterComponent;
    'bv-modal/footer': typeof BvModalFooterComponent;
  }
}
